import Store from 'Services/Store';

window.projectListing = {
	
	prepareFilterForm: function(action){
		
		$('.projectListProgressBar').each(function( index ) {
			var tmpRatio = parseInt($(this).attr('ratio'),10);
			$(this).progressbar({value:tmpRatio});
		});
		
		action = action == undefined ? "project_listing" : action;
		
		var options = {success:function(data){
				Listing.refresh("projectsListing", data, data.projects_metadatas);	
				$('.projectListProgressBar').each(function( index ) {
					var tmpRatio = parseInt($(this).attr('ratio'),10);
					$(this).progressbar({value:tmpRatio});
				});
		}, dataType:"json"};
        MyForm.prepare("projectsFilterForm", action+"&action=updateListing", options);
	}
	
};

window.projectEntriesListing = {
	
	prepareFilterForm: function(action){
		
		action = action == undefined ? "project_entrieslisting" : action;
		
		var options = {success:function(data){
			Listing.refresh("projectEntriesListing", data, data.projectEntries_metadatas);	
		}, dataType:"json"};
        MyForm.prepare("projectEntriesFilterForm", action+"&action=updateListing", options);
	}
	
};

window.externalProjectEntriesListing = {
	
	prepareFilterForm: function(action){

		action = action == undefined ? "project_externalEntriesListing" : action;
		
		var options = {success:function(data){
			Listing.refresh("projectEntriesListing", data, data.projectEntries_metadatas);	
		}, dataType:"json"};
        MyForm.prepare("projectEntriesFilterForm", action+"&action=updateListing", options);
	}
	
};

window.project = {

	initOverview: function(comptactMode){
		
		project.initDom();
		project.initProgressBar();
		
		$(document).ready(function(){
			project.adaptDom();
		});
		
		$(window).resize(function(){
			project.adaptDom();
		});
		
		
		$('#projectOverview').on('click','.projectRightBar .chief', function(e){
			var newChief = $(this).attr('chiefid');
			var oldChief = $('#projectOverview .projectRightBar .chief.isChief').attr('chiefid');
			project.toggleProjectChief(newChief, oldChief);
		});
		
		$('#projectOverview').on('click','.projectMode .mode', function(e){
			var mode = $(this).attr('mode');
			project.switchMode(mode);
		});
		
		$('#projectOverview').on('click','.projectCompactMode .compactMode', function(e){
			var comptactMode = $(this).attr('compactMode');
			project.switchCompactMode(comptactMode);
		});
		
		$('#projectOverview').on('click','.projectViewArchive .archiveActivity', function(e){
			var mode = $(this).attr('mode');
			project.switchArchive(mode);
		});

		$('#projectOverview').on('click','.projectCalendarView .calendarMode', function(e){
			var mode = $(this).attr('mode');
			project.switchCalendarMode(mode);
		});
		
		$('#projectOverview .projectListSubContainer').on('click', '.entryClick', function(e){
			var eid = $(this).closest('.projectOneListCard').attr('eid');
			var pid = $(this).closest('.projectOneListCard').attr('pid');
			var lid = $(this).closest('.projectOneListCard').attr('lid');
			project.entryOverview(pid,lid,eid);
		});
		
		$('#projectOverview').on('click', '.entryOpenTab', function(e){
			var eid = $(this).closest('.projectOneListCard').attr('eid');
			var pid = $(this).closest('.projectOneListCard').attr('pid');
			var lid = $(this).closest('.projectOneListCard').attr('lid'); 
			var tab = $(this).attr('tab');
			project.entryOverview(pid,lid,eid,tab);
		});
		
		$('#projectOverview').on('click', '.fastListAddTrigger', function(){
			project.fastEntryForm($(this));
		});
		
		$('#projectOverview').on('click','.cardHistory', function(){
			$(this).closest('.projectOneList').toggleClass('flipped');
		});
		
		$('#projectOverview').on('click', '.actionContext .actionBars', function(e){
			Utils.triggerContextMenu(e, $(this));
		});
		
		$('#projectOverview').on('click', '.actionContext .subscribe', function(e){
			var eid			= $(this).closest('.projectOneListCard').attr('eid');
			var pid			= $(this).closest('.projectOneListCard').attr('pid');
			var lid			= $(this).closest('.projectOneListCard').attr('lid');
			var subscribed	= $(this).closest('.projectOneListCard').attr('subscribed');
			var subscrib = subscribed == "Y" ? "N" : "Y";
			$(this).closest('.projectOneListCard').attr('subscribed', subscrib);
			project.entryUserSubscribe(pid,lid,eid,subscrib);
		});
		
		$('#projectOverview').on("keyup", ".searchInList", function(e){
			
			var containerToSearch = $(this).closest('.projectOneList').find('.projectOneListCards');
			var search = $(this).val();
			if (search.length >= 1){
				containerToSearch.find('.entryIdent').not(":insensitivecontains('"+search+"')").closest('.projectOneListCard').hide();
				containerToSearch.find(".entryIdent:insensitivecontains('"+search+"')").closest('.projectOneListCard').show();
				$('.front .projectOneListCards').sortable( "disable" );
			} else if (search.length < 1) {
				containerToSearch.find('.projectOneListCard').show();
				$('.front .projectOneListCards').sortable( "enable" );
			}
		});
		
		$('#projectOverview').on("click", ".cleanSearch", function(e){
			$(this).closest('.projectOneList').find('.projectOneListCards').find('.projectOneListCard').show();
			$(this).closest('.projectOneList').find('.searchInList').val('');
			$('.front .projectOneListCards').sortable( "enable" );
		});
		
		var entryToLoad = $('#entryToLoad').val();
		
		if (entryToLoad != '' && $("[eid="+entryToLoad+"]").length > 0){
			$("[eid="+entryToLoad+"]").find('.entryClick').trigger('click');
		}

		project.switchCompactMode(comptactMode);
	},
	
	initProgressBar: function(){
		
		var nbEntries = parseInt($('#projectOverview .projectOneListCard').length,10);
		var nbEntriesComplete = parseInt($('#projectOverview .back .projectOneListCard').length,10);
		var ratio = Math.round((nbEntriesComplete / nbEntries )*100);
		
		if (isNaN(ratio)){
			ratio = 0;
		}
		
		$('#projectOverview').find('.projectGlobalProgressBar').progressbar({
			value : ratio
		});

		$('#projectOverview').find('.projectGlobalProgressBar .progress-label').html(ratio + " %");
		
	},
	
	toggleProjectChief: function(newChief, oldChief){
		
		var pid		= $('#projectid').val();
		
		var datas = {
			action		: "toggleProjetChief",
			pid			: pid,
			newChief	: newChief,
			oldChief	: oldChief
		};
		
		MyFacture.post("project_ajax", datas, function(data){
			if (data.status === "success"){
				$('#projectOverview .projectRightBar .chief[chiefid='+newChief+']').attr('class','fa fa-star isChief chief fa-blue');
				$('#projectOverview .projectRightBar .chief[chiefid='+oldChief+']').attr('class','fa fa-star-o notChief chief');
			}
		}, 'json');
		
	},
	
	switchCompactMode: function(compactMode){
		
		switch (compactMode){
			case "compact":
				$('.projectListContainer').addClass('compactMode');
				
				$('.projectCompactMode .compactMode[compactMode="compact"]').hide();
				$('.projectCompactMode .compactMode[compactMode="normal"]').show();
				
				break;
				
			case "normal":
				$('.projectListContainer').removeClass('compactMode');
				$('.projectCompactMode .compactMode[compactMode="compact"]').show();
				$('.projectCompactMode .compactMode[compactMode="normal"]').hide();
				break;
		}
		
		project.adaptDom();

	},
	
	switchMode: function(mode){
		
		switch (mode){
			case "compact":
				$('.projectMode .mode[mode="compact"]').hide();
				$('.projectMode .mode[mode="normal"]').show();
				$('.projectRightBarCompact').show();
				$('.projectRightBar').hide();
				
				break;
				
			case "normal":
				$('.projectMode .mode[mode="compact"]').show();
				$('.projectMode .mode[mode="normal"]').hide();
				$('.projectRightBarCompact').hide();
				$('.projectRightBar').show();
				break;
		}
		
		project.adaptDom();
		
	},
	
	switchArchive: function(mode){
	
		switch (mode){
			case "active":
				$('.projectViewArchive .archiveActivity[mode="active"]').hide();
				$('.projectViewArchive .archiveActivity[mode="history"]').show();
				$('.projectOneList').addClass('flipped');
				break;
				
			case "history":
				$('.projectViewArchive .archiveActivity[mode="active"]').show();
				$('.projectViewArchive .archiveActivity[mode="history"]').hide();
				$('.projectOneList').removeClass('flipped');
				break;
		}
		
		project.adaptDom();
		
	},
	
	switchCalendarMode: function(mode){
		switch (mode){
			case "active":
				$('.projectCalendarView .calendarMode[mode="active"]').hide();
				$('.projectCalendarView .calendarMode[mode="calendar"]').show();
				$('.projectListCalendar').show();
				$('.projectListSubContainer').hide();
				$('.projectListContainer').css('overflow-y', 'auto');
				project.initCalendarMode();
				break;
				
			case "calendar":
				$('.projectCalendarView .calendarMode[mode="active"]').show();
				$('.projectCalendarView .calendarMode[mode="calendar"]').hide();
				$('.projectListCalendar').hide();
				$('.projectListSubContainer').show();
				$('.projectListContainer').css('overflow-y', 'hidden');
				$('.listIdent').each(function( eventIndex, eventData) {
					$(this).css('display', 'none');
				});
				break;
		}
		
	},
	
	initCalendarMode: function(){
		
		if ($('#projectcalendar').html() === '' && $('.fc-event-container').length === 0){
			
			project.initCalendar($('#projectcalendar').attr('startTime'), $('#projectcalendar').attr('endTime'), $('#projectcalendar').attr('days'));
			
		} else {
			
			project.refreshCalendar();
			
		}
	},
	
	refreshCalendar: function() {
		if ($('#projectcalendar').find('.fc-view-container').length > 0) {
			setTimeout(function(){
				$('#projectcalendar').fullCalendar('refetchEvents');
			}, 1000);
		}
	},
	
	initCalendar: function(startTime, endTime, days){
		
		var relatedtype		= $("#projectcalendar").attr('relatedtype');
		var relatedid		= $("#projectcalendar").attr('relatedid');
		var aspectratio		= $("#projectcalendar").attr('ratio');
		var defaultView		= $("#projectcalendar").attr('defaultView');
		var headerLeft		= $("#projectcalendar").attr('headerLeft');
		var headerCenter	= $("#projectcalendar").attr('headerCenter');
		var headerRight		= $("#projectcalendar").attr('headerRight');
		var selectable		= $('#projectcalendar').attr('selectable');
		
		var uiLang      = Loc.uilang;
		var hoursFormat = Store.get('corp').hourformat;
		var timeformat  = hoursFormat === "12" ?	'hh:mm a' : 'HH:mm';
		
		relatedtype	 = relatedtype === undefined ? 0 : relatedtype;
		relatedid	 = relatedid === undefined ? 0 : relatedid;
		aspectratio	 = aspectratio === undefined ? 1.35 : parseFloat(aspectratio);
		defaultView	 = defaultView === undefined ? 'month' : defaultView;
		headerLeft	 = 'title, prev, next';
		headerCenter = 'month, agendaWeek, agendaDay';
		headerRight  = 'today';
		selectable	 = selectable === undefined ? true : (selectable === 'Y');

		this.calendar = $('#projectcalendar').fullCalendar({

			/* General display */
			firstDay: uiLang === 'fr' ? 1 : 0,
			aspectRatio: aspectratio,
			handleWindowResize: false,
			header: {
				left: headerLeft,
				center: headerCenter,
				right: headerRight
			},
			
			defaultView: defaultView,

			/* Text/Time Customization */
			allDayText: Loc.g('Toute la journée'),
			// Traduction && Formatting
			timeFormat: timeformat,
			slotLabelFormat : timeformat,
			weekNumbers: true,
			weekNumberTitle: (uiLang === 'fr') ? 'S' : 'W',
			weekNumberCalculation: 'ISO',
			slotDuration: '00:15:00',
			nextDayThreshold: "00:00:00",
                        
                        
			displayEventEnd: true,
                        
			buttonText: {
				today : Loc.g("Aujourd'hui")
			},
			monthNames: [Loc.g('Janvier'), Loc.g('Février'), Loc.g('Mars'), Loc.g('Avril'), Loc.g('Mai'), Loc.g('Juin'), Loc.g('Juillet'), Loc.g('Août'), Loc.g('Septembre'), Loc.g('Octobre'), Loc.g('Novembre'), Loc.g('Décembre')],
			monthNamesShort: [Loc.g('Jan'), Loc.g('Fev'), Loc.g('Mar'), Loc.g('Avr'), Loc.g('Mai'), Loc.g('Jui'), Loc.g('Juil'), Loc.g('Au'), Loc.g('Sep'), Loc.g('Oct'), Loc.g('Nov'), Loc.g('Dec')],
			dayNames: [Loc.g('Dimanche'), Loc.g('Lundi'), Loc.g('Mardi'), Loc.g('Mercredi'), Loc.g('Jeudi'), Loc.g('Vendredi'), Loc.g('Samedi')],
			dayNamesShort: [Loc.g('Dim'), Loc.g('Lun'), Loc.g('Mar'), Loc.g('Mer'), Loc.g('Jeu'), Loc.g('Ven'), Loc.g('Sam')],
			views: {
				week: {// name of view
					titleFormat: 'DD MMMM YYYY',
					columnFormat: 'dddd DD/MM',
					buttonText: Loc.g('Semaine'),
				},
				day: {// name of view
					titleFormat: 'dddd DD MMMM YYYY',
					columnFormat: 'dddd',
					buttonText: Loc.g('Jour'),
				},
				month: {// name of view
					columnFormat: 'dddd',
					buttonText: Loc.g('Mois'),
				},
				listYear: {
					buttonText: Loc.g('Liste Année'),
				},
				listMonth: {
					buttonText: Loc.g('Liste Mois'),
				},
				listWeek: {
					buttonText: Loc.g('Liste Semaine'),
				},
				listDay: {
					buttonText: Loc.g('Liste Jour'),
				}
			},
			listDayFormat: 'dddd DD MMMM YYYY',
			listDayAltFormat: false,
			noEventsMessage: Loc.g("Il n'y a aucun évènement à afficher"),
			
			eventRender : function(event, element, view) {
				switch (event.projectEventType){
					
					case "projectEntry":
						$('.listIdent').each(function( eventIndex, eventData) {
							$(this).css('display', 'inline-block');
						});
						var content = $('#projectOverview .projectListContainer .projectOneList .front .projectOneListCard[eid='+event.eid+']').clone();
						element.find('.fc-content').replaceWith(content);
						break;
						
					case "projectEvent":

						// time render, removed if not in month view (when there is one)
						element.find('.fc-widget-content').css('min-height', '80px');
						if (!(view.name === 'month')) {
							var timeDiv = element.find('.fc-time');
							if (timeDiv) {
								timeDiv.remove();
							}
						}
						// to force textColor in black
						element.css('color', event.textColor);

						// to put the bracket at left
						if (view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear") {
							element.css('padding', '7px 5px')
									.css('border-radius', '0px')
									.css('border-left', '10px solid #FFF');
						} else {
							element.css('padding', '7px 5px')
									.css('border-radius', '0px')
									.css('border-left', '3px solid #FFF');
						}

						// style
						if (event.backgroundColor === undefined) {
							event.backgroundColor = '#F7FBFD';
							event.borderColor = '#F7FBFD';
						}

						element.css('background-color', event.backgroundColor)
								.css('border-color', event.borderColor)
								.css('border-left-color', event.labelcolor)
								.css('opacity', event.opacity);

						if (view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear") {
							element.find('.fc-title-viewList')
									.html(event.title)
									.css('display', 'inline-block')
									.css('width', 'calc(100% - 30px)')
									.css('white-space', 'normal');
						} else {
							element.find('.fc-title')
									.html(event.title)
									.css('display', 'inline-block')
									.css('width', 'calc(100% - 30px)')
									.css('white-space', 'normal')
									.css('float', 'left');
						}

						// render

						var actualContent = element.find('.fc-content').html();
						if (view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear") {
							actualContent = element.find('.fc-list-item-title').html();
						}

						var hasLinked = false;
						var contentLinked = '';
						if (event.linkedurl !== undefined && event.linkedurl !== '') {
							hasLinked = true;
							contentLinked = '<span class="eventLinked" style="float:left;"><i class="fa ' + event.iconObject + '" style="margin-right: 2px;"></i> ' + event.linkedurl + '</span>';
						}

						var mainContent = '<div>' + (event.isEventRecurring === "Y" ? '<i class="fa fa-history fa-block" style="margin-right: 2px;float:right;"></i>' : '') + actualContent + '</div>' + (hasLinked ? '<div>' + contentLinked + '</div>' : '');
						var imageContent = '';
						if (event.owneradv !== undefined) {
							if (event.owneradv.type === 'initials') {
								if (event.nbStaff > 1) {
									imageContent = '<div class="avatar avatar-small">';
									imageContent += '<span style="border-radius: 20px; opacity: 0.3;">' + event.owneradv.value + '</span>';
									imageContent += '<div style="position:relative; display:block; top: -15px; margin-left: 1px; color:black;">' + event.nbStaff + '</div>';
									imageContent += '</div>';
								} else {
									imageContent = '<span class="avatar avatar-small">' + event.owneradv.value + '</span>';
								}
							} else {
								if (event.nbStaff > 1) {
									imageContent = '<div class="avatar avatar-small avatar-picture">';
									imageContent += '<img src="' + event.owneradv.value + '" style="width:100%; border-radius: 20px; opacity: 0.3;"/>';
									imageContent += '<div style="position:relative;display:block; top: -20px;font-size:12px;text-align:center;font-weight:700;">' + event.nbStaff + '</div>';
									imageContent += '</div>';
								} else {
									imageContent = '<div class="avatar avatar-small avatar-picture"><img src="' + event.owneradv.value + '" style="width:100%; border-radius: 20px;" /></div>';
								}
							}
						} else if (event.ownerpic !== undefined) {
							imageContent = '<img src="' + event.ownerpic + '" stafftip="' + event.ownerid + '" style="margin-right:5px;vertical-align:top;float:left;" class="staffpic-25" />';
							if (event.nbStaff > 1) {
								imageContent += '<div style="position:relative;display:block;color:white;top: -20px;font-size:12px;text-align:center;font-weight:700;">' + event.nbStaff + '</div>';
							}
						}

						var content = '<div>';

						if (event.tips != "") {
							content += '<div tips="' + event.tips + '" positiontips="top" style="width: 30px; display: inline-block;">' + imageContent + '</div>';
						} else {
							content += '<div style="width: 30px; display: inline-block;">' + imageContent + '</div>';
						}
						content += '<div style="width: calc(100% - 30px); display: inline-block; vertical-align: top;">' + mainContent + '</div>';
						content += '</div>';

						if (view.name == "listMonth" || view.name == "listWeek" || view.name == "listDay" || view.name == "listYear") {
							element.find('.fc-list-item-title').html(content);
						} else {
							element.find('.fc-content').html(content);
						}
						break;
				}
			},
			eventAfterAllRender : function(){
				project.initDom();
				Qtip.init();
			},
			editable: true,
			eventDrop: function( event, delta, revertFunc, jsEvent, ui, view ) { 
				
				switch (event.projectEventType){
					
					case "projectEntry":
						var start = event.start;
						var startFormatted = start.format('YYYY-MM-DD HH:mm:ss');
						project.updateEntryDueDate(event.pid, event.lid, event.eid, startFormatted);
						break;
						
					case "projectEvent":
						break;
						
				}
				return false;
				
			},
			
			eventResize: function(event, dayDelta, minuteDelta, revertFunc, jsEvent, ui, view) {
			},

			selectable: selectable,
			selectHelper: true,
			select: function( start, end, jsEvent, view ) {
				project.entryForm($('#projectid').val(), '', '', start.format('YYYY-MM-DD HH:mm:ss'));
			},

			eventClick: function(calEvent, jsEvent, view) {

				// if click is not in .entryClick block, don't trigger click
				if(!($(jsEvent.target).parents('.entryClick').length)){
					return;
				}

				switch (calEvent.projectEventType){
					case "projectEntry":
						project.entryOverview(calEvent.pid,calEvent.lid,calEvent.eid);
						break;
						
					case "projectEvent":
						
						var currentPid = $('.projectListSubContainer .projectOneListCard[eid="'+calEvent.relatedid+'"]').attr('pid');
						var currentLid = $('.projectListSubContainer .projectOneListCard[eid="'+calEvent.relatedid+'"]').attr('lid');
						var currentEid = $('.projectListSubContainer .projectOneListCard[eid="'+calEvent.relatedid+'"]').attr('eid');
						project.entryOverview(currentPid,currentLid,currentEid, 'calendarview');
						
						break;
				}
			},
			
			events: function(start, end, timezone, callback) {
				var eventsTmp = $('#projectOverview .projectListContainer .projectOneList .front .projectOneListCard');
				var events = [];
				var entriesIds = [];
				
				$.each(eventsTmp, function( eventIndex, eventData) {
					
					var tmpCalendarEvent = {
						title : "test",
						start: $(eventData).attr('calendarduedate'),
						eid : $(eventData).attr('eid'),
						lid : $(eventData).attr('lid'),
						pid : $(eventData).attr('pid'),
						projectEventType : 'projectEntry', 
						
					};
					
					entriesIds.push($(eventData).attr('eid'));
					
					if(tmpCalendarEvent.start !== '') {
						events.push(tmpCalendarEvent);
					}
				});
				
				MyFacture.cleanQueue();
				var action		= "agenda&action=updateEvents";
				var data		= {
					start		: start.format('YYYY-MM-DD HH:mm:ss'),
					end			: end.format('YYYY-MM-DD HH:mm:ss'),
					relatedtype : 'projectEntry',
					relatedids  : entriesIds,	
					forCalendar : 'Y',
					usePrefs    : 'N',
				};
				var success		= function(data) {
					$('#projectcalendar').find('.fc-button').addClass('btn btn-primary btn-small').removeClass('fc-state-default');
					$.each(data, function(key, value){
						value.projectEventType	= 'projectEvent';
						value.editable			= false;
						events.push(value);
					});
					callback(events);
					
				};
				MyFacture.post(action, data, success, 'json', true);
				
			}
			
		});
		
	},
	
	adaptDom: function(){
		
		var docHeight = document.body.clientHeight;
		var headerHeight = $('#header').height();
		
		$('#contentDiv').css('padding-bottom','0');
		
		// addapt right panel height
		var rightPanelHeight = docHeight-headerHeight;
		$('.projectRightBar, .projectRightBarCompact').height(rightPanelHeight);
		
		// adapt projectlistcontainer
		var projectListHeight = docHeight - $('.projectListContainer').offset().top - 10;
		$('.projectListContainer').height(projectListHeight);
		
		// adapt full middle container
		var contentMarginWidth = $('.contentMargin').innerWidth();
		var rightWidth = $('.fullProjectRightContainer').innerWidth();
		var middleWidth = contentMarginWidth - rightWidth;
		$('.fullMiddlecontainer').width(middleWidth);
		
		// adapt projectOneList height
		var projectTopHeight = $('.projectTopBar').height();
		var oneListHeight = $('.fullMiddlecontainer').height() - projectTopHeight - 60;
		$('.projectOneList').height(oneListHeight);
		$('.projectOneList .front .projectOneListCards').height(oneListHeight - 125);
		$('.projectOneList .back .projectOneListCards').height(oneListHeight - 110);
		
		// adpat projectListSubContainer width
		var nbLists = $('.projectOneList').length;
		if (nbLists > 0){
			var listWidth = $('.projectOneList').width() + 12;
			var fullWidth = nbLists * listWidth + 20;
			$('.projectListSubContainer').width(fullWidth);
		} else {
			$('.projectListSubContainer').width('100%');
		}
		
	},
	
	initLinkedUserDom: function(){
		
		$('.linkedUsers .link_staff .avatar, .linkedUsers .link_thirdContact .avatar').draggable({ 
			revert: false, 
			helper: "clone",
			containment: $('#projectOverview'), 
			appendTo: $('#projectOverview'), 
			scroll: 'false',
		});
		
		$(".projectOneListCard").droppable({hoverClass: "ui-droppable-drophover", accept: ".oneLinked .avatar", drop: function(event, ui) {
			var dragabble = ui.draggable.closest('li');
			var droppable = $(this);
			
			var pid = droppable.attr('pid');
			var lid = droppable.attr('lid');
			var eid = droppable.attr('eid');
			
			var linkinfo = dragabble.attr('linkinfo');

			MyFacture.post("project_ajax", {action:"linkUserToEntry", pid:pid, lid:lid, eid:eid, linkinfo:linkinfo}, function(data){
				if (data.link == 'success'){
					project.reloadEntry(pid,lid,eid,true);
				} else {
					MyWindow.alert(Loc.g('Utilisateur déjà présent sur cette entrée.'), {type:'warning'})
				}
			}, "json");
			
		}});
	
		$('.projectOneListCard .entry-linked-users li').click(function(){
			
			var linkInfo = $(this).attr('linkinfo');
			
			var parent = $(this).closest(".projectOneListCard");
			var pid = parent.attr('pid');
			var lid = parent.attr('lid');
			var eid = parent.attr('eid');
			
			var options = {

				type	: 'warning',
				buttons : [
                    {
                        text : Loc.g("Annuler"),
                        click : function(){
                            $(this).dialog("close");
                        }
                    },
                    {
						text : Loc.g("Délier"),
						click : function(){
							$(this).dialog("close");
							MyFacture.post("project_ajax", {action:"unlinkUserToEntry", pid:pid, lid:lid, eid:eid, linkinfo:linkInfo}, function(data){
								project.reloadEntry(pid,lid,eid,true);
							}, "json");
						}
					}
				]
			};
			
			MyWindow.alert(Loc.g('Délier le collaborateur de l’entrée ?'), options);
			
		});
	
	},
	
	initDom: function(){
		
		project.initLinkedUserDom();
		
		var scrollingSensitivity = 20, scrollingSpeed = 60;	
		
		$("#sortableList .projectListSubContainer").sortable({
			opacity: 1,
			delay : 0,
            revert: true,
			handle: ".projectOneListTitle",
			cursor: "crosshair",
			axis: "x",
			tolerance: "pointer",
			scroll: false,
			update: function( event, ui ) {project.orderOverviewList(event, ui)},
			sort: function(event, uiHash){
				
				var scrollContainer = uiHash.placeholder[0].parentNode.parentNode;
				var overflowOffset = $(scrollContainer).offset();
				
				if ($('.projectOneList:last').not('.ui-sortable-helper')){
					var dropOffest = uiHash.offset.left;
					
					
					var $lastList		= $('.projectOneList:last').not('.ui-sortable-helper');
					if ($lastList.length > 0){
						var lastOffset = $lastList.offset().left + 300;
						if (dropOffest < lastOffset){
							if ((overflowOffset.left + scrollContainer.offsetWidth) - event.pageX < scrollingSensitivity) {
								scrollContainer.scrollLeft = scrollContainer.scrollLeft + scrollingSpeed;
							} else if (event.pageX - overflowOffset.left < scrollingSensitivity) {
								scrollContainer.scrollLeft = scrollContainer.scrollLeft - scrollingSpeed;
							}
						}
					}

				}
				
			}
        }); 
		
		$('.front .projectOneListCards').sortable({
			items: ".projectOneListCard",
			opacity: 1,
			delay: 0,
			revert: true,
			connectWith: ".projectOneListCards",
			helper: 'clone',
			tolerance: "pointer",
			containement: ".projectListContainer",
			scroll: false,
			stop: function(event, ui) {
				project.moveOverviewEntry(event, ui);
			},
			sort: function(event, uiHash) {
				var scrollContainer = uiHash.placeholder[0].parentNode;
				var overflowOffset = $(scrollContainer).offset();
				
				// manage scroll vertical
				if ((overflowOffset.top + scrollContainer.offsetHeight) - event.pageY < scrollingSensitivity) {
					scrollContainer.scrollTop = scrollContainer.scrollTop + scrollingSpeed;
				} else if (event.pageY - overflowOffset.top < scrollingSensitivity) {
					scrollContainer.scrollTop = scrollContainer.scrollTop - scrollingSpeed;
				} 
				
				// manage scroll horizontal
				var lastOffset = $('.projectOneList:last').not('.ui-sortable-helper').offset().left + 300;
				var dropOffest = uiHash.offset.left;
				if (dropOffest < lastOffset){
					scrollContainer = $(scrollContainer).closest('.projectListContainer')[0];
					overflowOffset = $(scrollContainer).offset();
					if ((overflowOffset.left + scrollContainer.offsetWidth) - event.pageX < scrollingSensitivity) {
						scrollContainer.scrollLeft = scrollContainer.scrollLeft + scrollingSpeed;
					} else if (event.pageX - overflowOffset.left < scrollingSensitivity) {
						scrollContainer.scrollLeft = scrollContainer.scrollLeft - scrollingSpeed;
					}
				}
			}
		});
		
		$('#projectOverview').on("contextmenu", '.projectOneListCard', function(e){
			if (!$(this).hasClass('rightClickEnabled')){
				var rcOption = JSON.parse($(this).find('.rightClickOption').val());
				if (rcOption !== undefined){
					$(this).contextmenu(rcOption);
					$(this).addClass('rightClickEnabled');
				}
				Utils.triggerContextMenu(event, $(this));
			}
			return false;
		 });
		
	},
	
	displayError : function(fields){
		var divAlert = $('.alert:first');
		if(divAlert.length > 0){
			divAlert.empty();
			if(fields.length > 0){
				$.each(fields, function(i, field){
					if(field.msg.length > 0){
						divAlert.removeClass('hidden').css('display', '');
						divAlert.html().length > 0 && $('.alert').append('<br>');
						divAlert.append(field.msg);
					}	
				});
			}
		}
	},
	
	fastLinkForm: function(me){
		me = me.closest('.fastAdd');
		me.find('.toggler').hide();
		me.find('.autocomplete').show();
		
		MyFacture.customForm('#autcompleteHidden');
		
		$('#autocompleteType').val('staff');
//		$('#autocompleteType').selectmenu({style:'dropdown'});
		
		me.unbind('click');
		me.on('click', '.cancel', function(e){
			me.find('.toggler').show();
			me.find('.autocomplete').hide();
			var autoCompleteId = me.find('[e_autocontactlisting]').attr('id');
			$('#'+autoCompleteId).tokenInput("clear");
		});
		
		$('#autcompleteHidden .token-input-list').remove();
		TokenInput.autoStaff("#fastProject_addLinkedUser", 1, 'true', '','','',Loc.g('Ajouter un collaborateur'), 'N');
		
		$('#autocompleteType').change(function(){
			var val = $(this).val();
			$('#autcompleteHidden .token-input-list').remove();
			switch (val){
				case "staff":
					TokenInput.autoStaff("#fastProject_addLinkedUser", 1, 'true', '','','',Loc.g('Ajouter un collaborateur'), 'N');
					break;
				case "thirdContact":
					TokenInput.autoContactListing("#fastProject_addLinkedUser", 'thirdContact|supplierContact', 1, 'true', '','','',Loc.g('Ajouter un contact externe'));
					break;
				case "third":
					TokenInput.autoContactListing("#fastProject_addLinkedUser", 'third|prospect|supplier', 1, 'true','','','',Loc.g('Ajouter une société'));
					break;
			}
			
		});
		
		me.on('click', '.validate', function(e){
			
			me.find('.toggler').show();
			me.find('.autocomplete').hide();
			
			var autoCompleteId = me.find('#fastProject_addLinkedUser').attr('id');
			var linked = $('#'+autoCompleteId).tokenInput('get');
			
			if (linked.length == 0){
				
				MyWindow.alert(Loc.g('Veuillez choisir une personne / société'), {type:'warning'});
				
			} else {
				
				var pid		= $('#projectid').val();
				var title = Loc.g("Ajouter une personne / société");
				var options = {
					title	: title,
					width: 500,
					buttons	: [
                        {
                            text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
                        },
                        {
						text : Loc.g("Enregistrer"), click : function(){
							$("#projectFastLinkForm").submit();
						}}
						],
					callback	: function(){
						var alreadyExist = $('#pflf_linkAlreadyExist').val();
						if (alreadyExist == 'Y'){
							var newButtons = [{
								text : Loc.g("Fermer"), 'class': 'btn-default', click : function(){$(this).dialog("close");}
							}];
							MyWindow.addOption('buttons', newButtons);
						}
						project.prepareProjectFastLinForm();
					}
				};

				MyWindow.load("project_ajax", {action:"projectFastLinkForm", pid:pid, linked: linked}, options);
				
			}
			
			$('#'+autoCompleteId).tokenInput("clear");
		});
			
	},

	prepareProjectFastLinForm: function(){

		var formId = "projectFastLinkForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "projectFastLinkForm");
			if (formIsOk){

				if(	typeof data.email != 'undefined' &&
					data.email.type == 'error') {
					Nylas.connectError();
				}

				$.each(data.projectListAsVisible, function(i,v){
					if (v == 'Y'){
						$('.projectOneList[lid='+i+'] .listExternalVisible').addClass('fa-green');
					} else {
						$('.projectOneList[lid='+i+'] .listExternalVisible').removeClass('fa-green');
					}
				});

				if (data.status == "success") {
					// var html = '<li class="linked_'+data.staffDetails['type']+'_'+data.staffDetails.id+' oneLinked link_'+data.staffDetails['type']+'" linkinfo='+data.staffDetails['type']+'_'+data.staffDetails.id+'>';
					var html = '<li class="linked_'+data.staffDetails['type']+'_'+data.staffDetails.id+' oneLinked link_'+data.staffDetails['type']+'" linkinfo='+data.staffDetails['type']+'_'+data.staffDetails.id+'>';
					html += '<table><tbody><tr><td style="width: 10px; vertical-align:middle">';

					if (data.staffDetails.avatar){
						if (data.staffDetails.avatar['type'] == "initials"){
							html += '<span class="avatar avatar-small">'+data.staffDetails.avatar.value+'</span>';
						} else {
							html += '<span class="avatar avatar-small avatar-picture"><img src="'+data.staffDetails.avatar.value+'"/></span>';
						}
					} else {
						html +=		'<span class="avatar avatar-small avatar-picture"><img src="'+data.staffDetails.pics+'" /></span>';
					}

					html += '</td><td style="width: 10px; vertical-align:middle; text-align:center; padding: 3px 0;">';

					if(data.staffDetails['type'] != 'third'){
						html +=			'<i chiefid="'+data.staffDetails['type']+'_'+data.staffDetails.id+'" class="fa fa-star-o notChief chief" tips="'+Loc.g('Chef de projet')+'"" positiontips="left"></i>';
					}

					switch (data.staffDetails['type']) {
						case "third":
							html += '<i class="fa fa-building" tips="'+Loc.g('Société')+'"></i>';
							break;
						case "staff":
							html += '<i class="fa icon-contact" tips="'+Loc.g('Collaborateur')+'"></i>';
							break;
						default:
							html += '<i class="fa icon-contact" tips="'+Loc.g('Collaborateur')+'"></i>';
							break;
					}

					html += '</td><td style="width: 100%; vertical-align: middle; padding: 4px 0;"><span>';

					if (data.staffDetails.linkedUrl != undefined && data.staffDetails.linkedUrl != ''){
						html += '<a href="'+data.staffDetails.linkedUrl+'" target="_blank">' + data.staffDetails.fullName + "</a>";
					} else {
						html += data.staffDetails.fullName;
					}

					html += '</span>';
					html += '<a href="javascript:;" class="close unLink mt-2 pt-1" onClick="project.unLinkLinked(\''+data.staffDetails.type+'\','+data.staffDetails.id+')"><i class="fa icon-trash"></i></a>';
					html += '</td></tr></tbody></table></li>';

					$('#projectOverview .projectRightBar .linkedUsers').append(html);

					var compactHtml = '<li class="linked_'+data.staffDetails.type+'_'+data.staffDetails.id+'" tips="'+data.staffDetails.fullName+'" positiontips="left">';

					if (data.staffDetails.avatar){
						if (data.staffDetails.avatar.type == "initials"){
							compactHtml += '<span class="avatar avatar-small">'+data.staffDetails.avatar.value+'</span>';
						} else {
							compactHtml += '<span class="avatar avatar-small avatar-picture"><img src="'+data.staffDetails.avatar.value+'"/></span>';
						}
					} else {
						compactHtml +=		'<span class="avatar avatar-small avatar-picture"><img src="'+data.staffDetails.pics+'" /></span>';
					}

					compactHtml += '</li>';
					$('#projectOverview .projectRightBarCompact .linkedUsers').append(compactHtml);


					$('#projectOverview').find('.noLinkedRight').hide();
					Qtip.init();
					project.initLinkedUserDom();
					$("#LinkedUsersContainer .nano").nanoScroller({ scroll: 'bottom', preventPageScrolling: true });
				}
				MyWindow.close();
			}

		}, dataType:"json"};
		var data = {action: 'recordProjectFastLinkForm'};
		MyForm.prepare(formId, "project_ajax&"+$.param(data), options, true);
		MyFacture.initEvent();

	},
	
	unLinkLinked: function(type, id){
		
		var pid		= $('#projectid').val();
		var msg		= "";
		
		switch (type){
			case "staff":
				msg = Loc.g('Etes vous sur de vouloir supprimer ce collaborateur du projet ?');
				break;
			case "third":
				msg = Loc.g('Etes vous sur de vouloir supprimer cette société du projet ?');
				break;
			case "thirdContact":
				msg = Loc.g('Etes vous sur de vouloir supprimer ce contact externe du projet ?');
				break;
		}
		
		var options = {
			
			type	: 'warning',
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Supprimer"),
					'class' : 'btn-primary',
					click : function(){
						$(this).dialog("close");
						MyFacture.post("project_ajax", {action:"unlinkLinked", pid:pid, type:type, id:id}, function(data){
							if (data.status == "success"){

								var parent = $("#projectOverview").find(".linked_"+type+"_"+id).closest('.projectRightBarSubContainer');
								$("#projectOverview").find("li[linkinfo='"+type+"_"+id+"']").remove();
								if (parent.find('.linkedUsers li').length == 0){
									parent.find('.noLinkedRight').show();
								}
							}

						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(msg, options);
		
	},
	
	fastEntryForm: function(me){
	
		me.hide();
		var fastListAdd = me.closest('.projectListAddEntry').find('.fastListAdd');
		fastListAdd.show().find('input').focus();
		
		$(document).mouseup(function (e){
			var container = fastListAdd;
			if (container.has(e.target).length === 0){
				container.hide();
				me.show();
				fastListAdd.find('input').val('');
			}
		});
		
		fastListAdd.find('input').keydown(function (e){
			if(e.keyCode == 13){
				var value = fastListAdd.find('input').val();
				var pid = me.closest('.projectOneList').attr('pid');
				var lid = me.closest('.projectOneList').attr('lid');
				project.submitFastEntryForm(pid, lid, value);
			}
		})
		
		fastListAdd.find('.fastListAddSubmit').unbind().click(function(){
			var value = fastListAdd.find('input').val();
			var pid = me.closest('.projectOneList').attr('pid');
			var lid = me.closest('.projectOneList').attr('lid');
			project.submitFastEntryForm(pid, lid, value);
		});
		
	},
	
	submitFastEntryForm: function(pid, lid, value){
		
		$('.projectOneList[lid='+lid+']').find('.fastListAddTrigger').show();
		$('.projectOneList[lid='+lid+']').find('.fastListAdd').hide().find('input').val("");
		
		if (value != ""){
			var datas = {action:"projectAddFastEntry", pid:pid, lid:lid, value:value};
			MyFacture.post("project_ajax", datas, function(data){
				var entry = data.projectEntry;
				
				$('.projectOneListCard[eid='+entry.id+']').remove();
				$('.projectOneList[lid='+entry.lid+'] .front').find('.emptyList').hide();
				$('.projectOneList[lid='+entry.lid+'] .front').find('.projectOneListCards').append(data.projectEntryHtml);
				$('.projectOneList[lid='+lid+'] ul').animate({ scrollTop: $('.projectOneList[lid='+lid+'] ul')[0].scrollHeight}, 500);
				project.initProgressBar();
				project.initLinkedUserDom();
				
			}, "json");
		}
		
		
	},
	
	entryRightClick: function(eid, action, tab){
		
		var currentProjectEntry = $('.projectOneListCard[eid='+eid+']');
		var eid = currentProjectEntry.attr('eid');
		var pid = currentProjectEntry.attr('pid');
		var lid = currentProjectEntry.attr('lid');
		
		switch (action){
			case "moveToOtherProject":
				project.moveEntryToAnotherProject(pid,lid,eid);
			break;
			case "overview":
				project.entryOverview(pid,lid,eid, tab);
				break;
			case "form":
				project.entryForm(pid,lid,eid);
				break;
				
			case "copy":
				project.copyEntry(pid,lid,eid);
				break;
				
			case "archive":
				project.archiveEntry(pid,lid,eid);
				break;
			case "unarchive":
				project.unArchiveEntry(pid,lid,eid);
				break;
			case "delete":
				project.deleteEntry(pid,lid,eid);
				break;
		}
		
	},

	updateLabelEntry: function(pid, eid, newlabelid, newlabeltext, colorhexa, from){
		var datas = {
			action:				"updateLabelEntry",
			pid:				pid,
			eid:				eid,
			newlabelid:			newlabelid,
		};


		MyFacture.post("project_ajax", datas, function(data){
			if (data.status == 'success'){
				if(from == 'projectOverview'){
					if(Utils.browserDetails.name == 'Apple Safari'){
						Utils.reload();
					} else{
						$('.projectOneListCard[eid='+eid+']').css('border-left', '4px solid ');
						$('.projectOneListCard[eid='+eid+']').css('border-left-color',colorhexa);

						$('#1-8.b-m-mpanel .b-m-item').each(function(){
							if($(this).prop('title') == newlabeltext){
								$(this).find('.b-m-ibody i').addClass('fa fa-check fa-15 fa-blue');
							} else{
								$(this).find('.b-m-ibody i').removeClass();
							}
						});

					}
				} else if(from == 'projectEntries'){
					Listing.update('projectEntriesListing', true);
				}
			} else{
				var options = {
					type:  "error",
					buttons : [
						{
							text : Loc.g("OK"),
							click : function(){
								$(this).dialog("close");
							}
						}
					]
				};

				MyWindow.alert(Loc.g("Une erreur s'est produite lors de l'enregistrement de l'entrée."), options);
			}

		}, "json");
	},
	
	updateNbentries: function(lid){
		
		var nbActiveEntries   = $('.projectOneList[lid='+lid+'] .front .projectOneListCard').length;
		var nbArchivedentries = $('.projectOneList[lid='+lid+'] .back .projectOneListCard').length;
		$('.projectOneList[lid='+lid+'] .nbActiveEntries').html(nbActiveEntries);
		$('.projectOneList[lid='+lid+'] .nbArchivedEntries').html(nbArchivedentries);
		
		if ($('.projectOneList[lid='+lid+'] .front').find('.projectOneListCard').length === 0 ){
			$('.projectOneList[lid='+lid+'] .front').find('.emptyList').show();
		}
		
		if ($('.projectOneList[lid='+lid+'] .back').find('.projectOneListCard').length === 0 ){
			$('.projectOneList[lid='+lid+'] .back').find('.emptyList').show();
		}
		
		project.initProgressBar();
		
	},
	
	moveOverviewEntry: function(event, ui){
		
		var pid		= $('#projectid').val();
		var item	= ui.item[0];
		var parent	= $(item).closest('.projectOneList')[0];
		var lid		= $($(item).closest('.projectOneList')[0]).attr('lid');
		
		if ($(parent).find('.projectOneListCard').length > 0){
			$(parent).find('.emptyList').hide();
		}
		
		if ($(event.target).closest('.projectOneListCards').find('.projectOneListCard').length === 0 ){
			$(event.target).closest('.projectOneListCards').find('.emptyList').show();
		}
		
		var orderedEntries = [];
		$.each($(parent).find('.projectOneListCard'), function(index, value){
			orderedEntries.push($(value).attr('eid'));
		});

		var datas = {
			action:				"moveProjectEntry",
			pid:				pid,
			movetolid:			$(parent).attr('lid'),
			movedeid:			$(item).attr('eid'),
			orderedEntries :	orderedEntries
		};
		
		
		MyFacture.post("project_ajax", datas, function(data){
			if (data.status == 'success'){
				$(item).attr("lid", lid);
				project.updateNbentries(data.movedStatus.fromLid);
				project.updateNbentries(data.movedStatus.toLid);
			}
			
		}, "json");
		
	},
	
	orderOverviewList: function(event, ui){
		
		var pid = $('#projectid').val();
		
		var item	= ui.item[0];
		var lid		= $($(item).closest('.projectOneList')[0]).attr('lid');
		
		var orderedList = [];
		$.each($('.projectListContainer .projectOneList'), function(index, value){
			orderedList.push($(value).attr('lid'));
		});
		
		var datas = {action:"orderProjectList", pid:pid, lid:lid, orderedlist:orderedList};
		MyFacture.post("project_ajax", datas, function(data){
		}, "json");
		
	},
	
	askDeleteProject: function(pid){
		
		var options = {
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Supprimer"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"deleteProject", pid:pid};
						MyFacture.post("project_ajax", datas, function(data){
							Listing.update('projectsListing', false);
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Êtes vous sur de vouloir supprimer le projet ?"), options);
		
	},
	
	
	askCopyProject: function(pid){
		
		var options = {
			title: Loc.g('Copier le projet'),
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Copier"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"copyProject", pid:pid, copy_checklist:"N"};
						MyFacture.post("project_ajax", datas, function(data){
							Listing.update('projectsListing');
						}, "json");
					}
				},
                {
					text : Loc.g("Copier avec les checkLists"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"copyProject", pid:pid, copy_checklist:"Y"};
						MyFacture.post("project_ajax", datas, function(data){
							Listing.update('projectsListing');
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("L'ensemble des listes ainsi que des éléments contenus dans celles-ci seront copiés ? Les personnes affectées, les tâches, évènements, commentaires, etc. ne seront pas copiés.<br /> <br /> Voulez vous continuer ?"), options);
		
	},
	
	projectDelete : function(pid){
	
		var options = {
			title : Loc.g('Supprimer le projet'),
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Supprimer"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"deleteProject", pid:pid};
						MyFacture.post("project_ajax", datas, function(data){
							Utils.relocate('?_f=project_listing');
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous êtes sur le point de supprimer le projet. Est-vous sur ?"), options);
		
	},
	
	projectForm: function(pid){
		
		var title = pid === undefined ? Loc.g('Nouveau projet') : Loc.g('Modification du projet')
		
		var options = {
			title	: title,
			width: 1200,
			buttons	: [
                {
                    text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
                },
                {
				text : Loc.g("Enregistrer"), click : function(){
					$("#projectForm").submit();
				}}
				],
			callback	: function(){project.prepareProjectForm();}
		};

		MyWindow.load("project_ajax", {action:"projectForm", pid: pid}, options);
		
	},
	
	prepareProjectForm: function(){
		
		var formId = "projectForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "projectForm");
			if (formIsOk){
				
				if (data.projectAction == "ProjectCreated"){
					Utils.relocate("?_f=project_project&action=overview&pid="+data.projectId);
				} else {
					var listingExist = $('#projectsListing_container').length > 0;
					if (listingExist){
						MyWindow.close();
						Listing.update('projectsListing');
					} else {
						Utils.relocate("?_f=project_project&action=overview&pid="+data.projectId);
					}
				}
				
			}
			
		}, dataType:"json"};
		var data = {action: 'recordProjectForm'};
		MyForm.prepare(formId, "project_ajax&"+$.param(data), options, true);
		MyFacture.initEvent();
		Qtip.init();
		
	},
	
	projectlistForm : function(pid, lid){
		
		var title = lid === undefined ? Loc.g("Ajouter une liste") : Loc.g('Modifier la liste');
		var options = {
			title	: title,
			width: 550,
			buttons	: [
                {
                    text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
                },
                {
				text : Loc.g("Enregistrer"), click : function(){
					$("#projectListForm").submit();
				}}
				],
			callback	: function(){project.prepareProjectListForm();}
		};

		MyWindow.load("project_ajax", {action:"projectListForm", pid: pid, lid:lid}, options);
		
	},
	
	prepareProjectListForm: function(){
		
		var formId = "projectListForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "projectListForm");
			if (formIsOk){
				MyWindow.close();
				if (data.projectList !== undefined){
					$('.projectOneList[lid='+data.projectList.id+']').find('.projectOneListTitleContent').html(data.projectList.ident).attr('tips', data.projectList.ident);
					$('.projectOneList[lid='+data.projectList.id+']').attr('style', 'background-color:#'+data.projectList.bgcolor);
					if (data.projectList.externalVisible == 'Y'){
						$('.projectOneList[lid='+data.projectList.id+'] .listExternalVisible').addClass('fa-green');
					} else {
						$('.projectOneList[lid='+data.projectList.id+'] .listExternalVisible').removeClass('fa-green');
					}
					project.adaptDom();
				}
				if (data.projectListHtml !== undefined){
					$('#projectOverview .projectListContainer .projectListSubContainer').append(data.projectListHtml);
					project.adaptDom();
				}
				project.initDom();
				Qtip.init();
				MyFacture.initEvent();
				$('.projectListPlaceHolder').hide();
				$('.projectTopBarAddEntry').show();
			}
		}, dataType:"json"};
		var data = {action: 'recordProjectListForm'};
		MyForm.prepare(formId, "project_ajax&"+$.param(data), options, true);
		MyFacture.initEvent();
		
		$('.colorPicker').colpick({
			layout		: 'hex',
			submit		: 0,
			colorScheme	: 'light',
			onChange	: function(hsb, hex, rgb, el, bySetColor) {

				$(el).parent().find('.append').css('background-color','#'+hex);
				// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
				$(el).val(hex);
			}
		}).unbind('keyup').keyup(function(){
			$(this).colpickSetColor(this.value);
		}).trigger('keyup');
		
		$('#plist_ident').focus();
		
	},

	initProjectMoveToAnotherProjectForm : function(formId){
		MyFacture.initEvent();
		
		TokenInput.autoProject('#pme_projectid'
			, function(item){
				var projectId = item.id.split('_');
				project.pme_projectCallBack(projectId[1], 'add', formId);
			}
			, function (item){
				var projectId = item.id.split('_');
				project.pme_projectCallBack(projectId[1], 'delete', formId);
			}
		); 

	},
	
	toggleProjectListHistory : function(lid){
		$('.projectOneList[lid="'+lid+'"]').toggleClass('flipped');
	},
	
	copyProjectList: function(pid, lid){

		var options = {
			title : Loc.g('Copier la liste.'),
			type:  "warning",
			width: 500,
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Copier"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"copyProjectList", pid:pid, lid:lid, copy_checklist:"N"};
						MyFacture.post("project_ajax", datas, function(data){
							Utils.reload();
						}, "json");
					}
				},
                {
					text : Loc.g("Copier avec les checksLists"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"copyProjectList", pid:pid, lid:lid, copy_checklist:"Y"};
						MyFacture.post("project_ajax", datas, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous êtes sur le point de copier la liste. Voulez-vous continuer ?"), options);

	},
	
	moveListToOtherProject : function(pid, lid){
		
		var title = Loc.g('Déplacer la liste vers un autre projet');
		
		var options = {
			title	: title,
			width	: 600,
			buttons	: [
				{
					text :	Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text :	Loc.g("Enregistrer"),
					click :	function(btn){
						MyForm.toggleDisabledForm({
							btn : 				$(btn.currentTarget),
							dataToCheckOnBody : 'projectMoveListFormDisabled'
						});

						$("#projectmoveListToAnotherProjectForm").submit();
					}
				}
			],
			callback : function(){
				project.prepareProjectmoveListToAnotherProjectForm(pid, lid);
			}
		};

		MyWindow.load("project_ajax", {action:"projectmoveListToAnotherProjectForm", pid: pid, lid:lid}, options);
	},

	prepareProjectmoveListToAnotherProjectForm: function(pid, lid){

		var formId = "projectmoveListToAnotherProjectForm";
		var options = {
			success:function(data){
				MyForm.toggleDisabledForm({
					btn : $('#popupWindow').next().find('button:first'),
					dataToCheckOnBody : 'projectMoveListFormDisabled',
					toEnabled : true
				});
				var formIsOk = MyForm.processJson(data, formId);
				if (formIsOk){
					MyWindow.close();
					$('.projectOneList[lid='+lid+']').fadeIn(200).remove();
					project.refreshCalendar();
					Qtip.init();
					project.initProgressBar();
					project.initLinkedUserDom();
					MyWindow.alert(Loc.g("La liste a bien été déplacée vers le projet"), {type:'confirm'});
				} else {
					project.displayError(data.form.fields);
				}
			}, dataType:"json"
		};
	
		var data = {action: 'recordProjectmoveListToAnotherProjectForm'};
		MyForm.prepare(formId, "project_ajax&"+$.param(data), options, true);
		project.initProjectMoveToAnotherProjectForm(formId);
	},

	deleteProjectList: function(pid, lid){
		
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Supprimer"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"deleteProjectList", pid:pid, lid:lid};
						MyFacture.post("project_ajax", datas, function(data){
							$('.projectOneList[lid='+lid+']').remove();
							project.adaptDom();
							if ($('.projectOneList').length == 0){
								$('.projectTopBarAddEntry').attr('style','display:none!important');
								$('.projectListPlaceHolder').show();
							}
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Supprimer la liste du projet ?"), options);
		
	},
	
	assignEntryTo: function(pid, lid, eid, sub){
		
		var datas = {action:"assignEntryTo", pid:pid, lid:lid, eid:eid, sub:sub};
		MyFacture.post("project_ajax", datas, function(data){
		}, "json");
		
	},
	
	archiveEntry: function(pid,lid,eid, from){
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
						if(from === 'entryListing'){
							Listing.update('projectEntriesListing', true);
						} else{
							project.entryOverview(pid,lid,eid);
						}
					}
				},
				{
					text : Loc.g("Terminer"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"archiveProjectEntry", pid:pid, lid:lid, eid:eid};
						MyFacture.post("project_ajax", datas, function(data){
							if(from === 'entryListing'){
                                EventBus.emit('listing:refresh');
								Listing.update('projectEntriesListing', true);
							} else{
								project.reloadEntry(pid,lid,eid,true);
							}
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Marquer l'entrée comme terminée ?"), options);
	},
	
	unArchiveEntry: function(pid,lid,eid,from){
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Marquer comme active"), 
					click : function(){
						$(this).dialog("close");
						var datas = {action:"unArchiveProjectEntry", pid:pid, lid:lid, eid:eid};
						MyFacture.post("project_ajax", datas, function(data){
							if(from === 'entryListing'){
                                Listing.update('projectEntriesListing', true);
                                EventBus.emit('listing:refresh');
							} else{
								project.reloadEntry(pid,lid,eid,true);
							}
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Marquer l'entrée comme active ?"), options);
	},
	
	deleteEntry: function(pid,lid,eid){
		
		var options = {
			type:  "warning",
			buttons : [
				{
					text :	Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : 	Loc.g("Supprimer"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"deleteProjectEntry", pid:pid, lid:lid, eid:eid};
						MyFacture.post("project_ajax", datas, function(data){
							$('.projectOneListCard[eid='+eid+']').remove();
							project.updateNbentries(lid);
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Supprimer l'entrée de la liste ?"), options);
		
	},
	
	copyEntry: function(pid, lid, eid){
		
		var title = Loc.g('Copier l’entrée');
		
		var options = {
			title	: title,
			width: 600,
			buttons	: [
				{
					text :	Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : 	Loc.g("Enregistrer"),
					click : function(){
						$("#projectEntryForm").submit();
					}
				}
			],
			callback	: function(){project.prepareProjectEntryForm();}
		};

		MyWindow.load("project_ajax", {action:"projectEntryForm", pid: pid, lid:lid, eid: eid, copy:'Y'}, options);
	},
	
	
	updateEntryDueDate: function(pid, lid, eid, dueDate){
		var options = {
			action:	"updateProjectEntryDueDate",
			lid:	lid,
			pid:	pid,
			eid:	eid,
			dueDate: dueDate
		};
		MyFacture.post("project_ajax", options, function(data){
			project.reloadEntry(data.projectEntry.pid, data.projectEntry.lid, data.projectEntry.id);
		}, "json");
		
	},
			
	moveEntryToAnotherProject: function (pid, lid, eid){
		
		var title = Loc.g('Déplacer vers un autre projet');
		
		var options = {
			title	: title,
			width	: 600,
			buttons	: [
				{
					text :	Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text :	Loc.g("Enregistrer"),
					click : function(){
						$("#projectmoveElementToAnotherProjectForm").submit();
					}
				}
			],
			callback	: function(){project.preparepProjectmoveEntryToAnotherProjectForm(pid, lid, eid);}
		};

		MyWindow.load("project_ajax", {action:"projectmoveEntryToAnotherProjectForm", pid: pid, lid:lid, eid: eid}, options);
	},
			
			
	preparepProjectmoveEntryToAnotherProjectForm: function(pid, lid, eid){

		var formId = "projectmoveElementToAnotherProjectForm";
		var options = {success:function(data){

			var formIsOk = MyForm.processJson(data, formId);

			if (formIsOk){
				MyWindow.close();
				MyWindow.alert(Loc.g("L'entrée a bien été changée de projet"), {type:'confirm'});

				if ($('.projectOneListCard[eid='+eid+']').length > 0){
					if(data.pid !== undefined && pid == data.pid){
						Utils.reload();
					} else {
						$('.projectOneListCard[eid='+eid+']').remove();
						project.updateNbentries(lid);
					}
				} else {
                    EventBus.emit('listing:refresh');
					Listing.update('projectEntriesListing', false);
				}

			} else {
				
				if(data.form.msg == 'mywindow_error'){
					MyWindow.error();
				}else{
					project.displayError(data.form.fields);
				}
			}
			
		}, dataType:"json"};
	
		var data = {action: 'recordProjectmoveEntryToAnotherProjectForm'};
		MyForm.prepare(formId, "project_ajax&"+$.param(data), options, true);
		project.initProjectMoveToAnotherProjectForm(formId);
	},

	pme_projectCallBack: function(projectid, action, formID){

		switch (formID){
			case "projectmoveElementToAnotherProjectForm":
				var container	= 'pme_projectListContainer';
				var listid		= 'pme_listid';

				break;

			case "projectEntryForm":
				var container	= 'pe_projectListContainer';
				var listid		= 'pentry_list';

				break;
		}

		var checkbox = $('#pentry_createIntoNewList');

		checkbox.removeAttr('checked');

		switch (action){
			case "add":

				if($('#'+formID + ' .' + container +' .token-input-list').length == 0){
					$('#'+formID + ' .' + container).find('.placeholder').addClass('hidden');
					$('#'+formID + ' .' + container).find('.form-group').not('.newProjectList').removeClass('hidden');


					checkbox.click(function(){
						var isChecked = $(this).is(':checked');

						$('#'+formID + ' .' + container +' .existingProjectList').toggleClass('hidden', isChecked);
						$('#'+formID + ' .' + container +' .newProjectList').toggleClass('hidden', !isChecked);

						var checkboxLinkEntry = $('#pentry_linkToExistingEntry');

						if(isChecked && checkboxLinkEntry.is(':visible') && checkboxLinkEntry.is(':checked')){
							checkboxLinkEntry.trigger('click');
						}

						if($('#'+listid).tokenInput('get').length){
							checkboxLinkEntry.parents('.linkToExistingEntryGroup').toggleClass('hidden', isChecked);
						}

						if(isChecked){
							if($('#'+listid).data("tokenInputObject") == "object"){
								$('#'+listid).tokeninput("clear");
							}
						}
					});

					TokenInput.autoProjectList('#'+listid,
						function(item) {
							if($('.linkToExistingEntryGroup').length > 0){
								var listId = item.id.split('_');
								project.pme_projectListCallBack(projectid, listId[1], 'add', formID);
							}
						},
						function(item) {
							if($('.linkToExistingEntryGroup').length > 0){
								var listId = item.id.split('_');
								project.pme_projectListCallBack(projectid, listId[1], 'delete', formID);
							}
						},
						{pid:projectid}
					);


				}

				break;

			case "delete":

				$('#'+formID+' .' + container).find('.placeholder').removeClass('hidden');
				$('#'+formID+' .' + container).find('.form-group').addClass('hidden');
				$('#'+formID+' .' + container + ' .token-input-list').remove();

				project.pme_projectListCallBack(projectid, 0, 'delete', formID);

				break;

		}

	},

	pme_projectListCallBack: function(projectid, listid, action, formID){
		switch (formID){
			case "projectEntryForm":
				var container	= 'linkToExistingEntryWrapper';
				var entryid		= 'pentry_entry';

				break;
		}

		var checkbox = $('#pentry_linkToExistingEntry');

		switch (action){
			case "add":

				checkbox.removeAttr('checked');

				if($('#'+formID+' .'+container+' .token-input-list').length == 0) {
					$('#'+formID+' .'+container).find('.placeholder').hide();
					$('#'+formID+' .'+container).find('.form-group').show();

					$('.linkToExistingEntryGroup').removeClass('hidden');

					checkbox.click(function(){
						var isChecked = $(this).is(':checked');

						$('#'+formID+' .'+container).toggleClass('hidden', !isChecked);
						$('#'+formID+' .pe_projectEntryContainer').toggleClass('hidden', isChecked);

						$('#'+formID+' .'+container+' .token-input-list').remove();

						if(isChecked){
							TokenInput.autoProjectEntry('#'+entryid, '', '', {projects: ['project_'+projectid], lists: [listid]}, 1);
						} else {
							$('#'+formID+' .'+container+' .token-input-list').remove();
							$('#'+formID+' .'+container).addClass('hidden');
						}
					});

				}
				break;

			case "delete":

				$('#'+formID+' .'+container+' .token-input-list').remove();
				$('.linkToExistingEntryGroup, .'+container, '#'+formID).addClass('hidden');
				$('#'+formID+' .pe_projectEntryContainer').removeClass('hidden');

				checkbox.removeAttr('checked');

				break;
		}

	},
	
	entryForm: function(pid, lid, eid, dueDate){
	
		var title = eid === undefined ? Loc.g("Ajouter une entrée") : Loc.g("Modifier l’entrée");
		
		var options = {
			title	: title,
			width: 600,
			buttons	: [
				{
					text :	Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : 	Loc.g("Enregistrer"),
					click : function(){
						$("#projectEntryForm").submit();
					}
				}
			],
			callback	: function(){project.prepareProjectEntryForm();}
		};

		MyWindow.load("project_ajax", {action:"projectEntryForm", pid: pid, lid:lid, eid: eid, dueDate:dueDate}, options);
		
	},
	
	prepareProjectEntryForm: function(){
		
		var formId = "projectEntryForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, "projectEntryForm");
				if (formIsOk){
					MyWindow.close();
					var entry = data.projectEntry;
					var insertAt = data.insertAt

					$('.projectOneListCard[eid='+entry.id+']').remove();

					var selector = '.front';
					if (entry.archived == "Y"){
						selector = '.back';
					}

					switch (insertAt){
						case 'first':
							$('.projectOneList[lid='+entry.lid+'] '+selector).find('.projectOneListCards').prepend(data.projectEntryHtml);
							break;
						case 'last':
							$('.projectOneList[lid='+entry.lid+'] '+selector).find('.projectOneListCards').append(data.projectEntryHtml);
							break;
						default:
							if ($('.projectOneList[lid='+entry.lid+'] '+selector+' .projectOneListCard[eid='+insertAt+']').length > 0){
								$('.projectOneList[lid='+entry.lid+'] '+selector+' .projectOneListCard[eid='+insertAt+']').after(data.projectEntryHtml);
							} else {
								$('.projectOneList[lid='+entry.lid+'] '+selector).find('.projectOneListCards').append(data.projectEntryHtml);
							}
							break;
					}

					$('.projectOneList[lid='+entry.lid+'] '+selector).find('.emptyList').hide();
					project.refreshCalendar();

					project.updateNbentries(entry.lid);
					project.initLinkedUserDom();

				}
			}, dataType:"json"
		};
		var data = {action: 'recordProjectEntryForm'};
		MyForm.prepare(formId, "project_ajax&"+$.param(data), options, true);
		MyFacture.initEvent();
		
	},
	
	
	createEntryFromTicket: function(pid, ticketid){
		
		var formID		= 'projectEntryForm';

		var options = {
			title	: Loc.g("Création / Liaison d'une entrée de projet"),
			buttons	: [
                {
                    text: 	Loc.g("Annuler"),
					click: function(){
						$(this).dialog("close");
					}
                },
                {
					text	: Loc.g("Enregistrer"),
					click	: function(btn) {
						var btn			= $(btn.currentTarget);
						var register	= btn.children('span');
						var body		= $('body');

						btn.attr('disabled', 'disabled');
						register.text(Loc.g('Chargement') + " ....");

						if(body.data('createEntryFromTicket') === undefined){
							body.data('createEntryFromTicket', false);
						}

						if(!body.data('createEntryFromTicket')){
							body.data('createEntryFromTicket', true);

							$("#"+formID).submit();
							MyFacture.customForm(formID);

						}
					}
				},
			],
			width: 600,
			callback: function(){
				project.prepareProjectEntryFormFromTicket('recordEntryFromTicket', formID);
			}
		};
		
		
		MyWindow.load("project_project", {action:"createEntryFromTicket", tid: ticketid}, options);
	},

	prepareProjectEntryFormFromTicket: function(action, formID){

			var body = $('body');
			body.data("createEntryFromTicket", false);

			var options = {
				success : function(data){
					var formOk = MyForm.processJson(data, formID);
					if(formOk){
						Utils.relocate('?_f=project_project&action=overview&pid=' + data.pid + '&eid=' + data.eid);
					} else {
						var body = $('body');
						body.data('createEntryFromTicket', false);
						var btn = $('#popupWindow').parent().find('.ui-dialog-buttonpane').find('button[type=button]').first();
						var register = btn.find('span.ui-button-text').first();
						btn.removeAttr('disabled');
						register.text(Loc.g('Enregistrer'));
					}
				},
				dataType: 'json'
			};

			MyForm.prepare(formID, "project_project&"+$.param({action: action}), options, true);

			TokenInput.autoProject('#pentry_pid',
				function(item) {
					var projectId = item.id.split('_');
					project.pme_projectCallBack(projectId[1], 'add', formID);
				},
				function(item) {
					var projectId = item.id.split('_');
					project.pme_projectCallBack(projectId[1], 'delete', formID);
				}
			);
		
	},
	
	entryFormChangeList: function(){
		
		var lid = $("#projectEntryForm #pentry_list option:selected").val()
		var pid	= $('#projectid').val();
		
		var datas = {
			action:	"getProjectEntries",
			lid:	lid,
			pid:	pid
		};
		
		MyFacture.post("project_ajax", datas, function(data){
			
			var list = $("#projectEntryForm #pentry_rank");
			var html = "<option value='first'>--"+Loc.g('En premier')+"</option>";
			$.each(data.entries, function(k,v){
				html += "<option value='"+v.id+"'>"+v.ident+"</option>";
			});
			html += "<option value='last'>--"+Loc.g('En dernier')+"</option>";
//			list.html(html).selectmenu({style:'dropdown'});
			list.html(html);
			
		}, "json");
		
	},
	
	entryOverview: function(pid,lid,eid, tab){

		var options = {
			width: 1200,
			title: Loc.g("Entrée de projet"),
			close: function(){
				if ($('#projectOverview').length > 0){
					project.reloadEntry(pid, lid, eid);
				}
				if ($("#projectEntriesListing_container").length > 0){
					Listing.update('projectEntriesListing');
				}
			},
			
			callback	: function(){

				$('#projectEntryOverview').on('click','.tab-h-menu li', function(){
					var tab = $(this).find('a').attr('id');
					project.saveEntryPreviewTab(pid,lid,eid,tab);
				});

				$('#projectEntryOverview').on('click','.projectEntryEdit', function(){
					project.entryForm(pid,lid,eid);
				});

				$('#projectEntryOverview').on('click','.projectEntryArchive', function(){
					project.archiveEntry(pid,lid,eid);
				});

				$('#projectEntryOverview').on('click','.projectEntryUnArchive', function(){
					project.unArchiveEntry(pid,lid,eid);
				});

				$('#projectEntryOverview').on('click','.projectEntrySubscribe', function(){
					var subscrib = $(this).hasClass('alreadySubscribed') ? "N" : "Y";
					project.entryUserSubscribe(pid,lid,eid,subscrib);
				});

				$('#projectEntryOverview').on('click','.unLinkElement', function(e){
					var linkid	= $(this).closest('li').attr('linkid');
					project.unLinkToEntry(pid,lid,eid,linkid);
				});

				$("#projectEntryOverview").on('click',".linkerSearch li", function(){

					$(this).toggleClass('active');

					var searchFull = [];
					$.each($("#projectEntryOverview .active"), function(k,v){
						searchFull.push(":not(.link_" +$(v).attr('search')+")");
					});

					$("#projectEntryOverview .linkerContent li").show();
					if (searchFull.length > 0){
						$("#projectEntryOverview .linkerContent li"+searchFull.join('')).hide();
					}


				});

				project.initEntryOverviewLinker();
				project.initEntryEIP(pid,lid,eid);
				MyTabs.initHorizontal('projectEntryOverview');

				if (tab !== undefined) {
					$('#entryOverviewContent .toolsContainer #'+tab).trigger('click');
				} else {
					tab = $('#projectEntryOverview .tab-h-container .current a').attr('id');

					if (tab === 'calendarview'){
						setTimeout(function(){
							Agenda.initCalendar($('#calendar').attr('startTime'), $('#calendar').attr('endTime'), $('#calendar').attr('days'), $('#calendar').attr('selectedView'));
						}, 1000);
					}
					if (tab === "tasks"){
						Agenda.loadTasksTab("projectentry", eid);
					}
				}

				BriefCaseV2Light.init();
				Annotation.init("projectEntryComments");
				checkListDisplayer.init();
				MyFacture.customForm();
			}
		};

		MyWindow.load("project_ajax", {action:"entryOverview", pid:pid, lid:lid, eid:eid}, options, true, "entryOverviewPopup");
		
	},
	
	projectTimetrackingSum: function(pid, lid){
			
			var title = Loc.g("Récapitulatif du timetracking");
			var options = {
				title	: title,
				width: 600,
				height: 600,
				buttons	: [
                    {
                        text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}
                    },
                    {
						text : Loc.g("Exporter le timetracking"), 'class' : "btn-primary", click : function(){
							Utils.relocate('?_f=project_export&action=timetracking&pid='+pid+'&lid='+lid);
						}
					}
					],
				callback	: function(){
					MyFacture.customForm();
					MyFacture.initEvent();
				}
			};

			MyWindow.load("project_ajax", {action:"projectTimetrackingSum", pid:pid, lid:lid}, options);
			
	},
	
	projectLinkSum: function(pid, lid){
		
		var title = Loc.g("Récapitulatif des liaisons");
			var options = {
				title	: title,
				width: 800,
				height: 600,
				buttons	: [
					{
						text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}
					}],
				callback	: function(){
					
					$("#projectLinkSum").on('click',".linkerSearch li", function(){
						$(this).toggleClass('active');
						var searchFull = [];
						$.each($("#projectLinkSum .active"), function(k,v){
							searchFull.push(":not(.link_" +$(v).attr('search')+")");
						});
						$("#projectLinkSum .linkerContent li").show();
						if (searchFull.length > 0){
							$("#projectLinkSum .linkerContent li"+searchFull.join('')).hide();
						}
					});
					
					MyFacture.customForm();
					MyFacture.initEvent();
				}
			};

			MyWindow.load("project_ajax", {action:"projectLinkSum", pid:pid, lid:lid}, options);
			
	},
	
	initEntryEIP : function(pid,lid,eid){

		$('#projectEntryOverview').find('.EIP_displayer, .EIP_editToggler').not('.EIP_disabled').unbind('click').click(function(e){
			
			// get current
			var container	= $(this).closest('.EIP_container');
			var field		= container.attr('EIP_field');
			var displayer	= container.find('.EIP_displayer');
			var editor		= container.find('.EIP_editor');
			var toggler		= container.find('.EIP_editToggler');
			
			// hide other
			$('#projectEntryOverview').find('.EIP_displayer, .EIP_editToggler').show();
			$('#projectEntryOverview').find('.EIP_editor').hide();

			// process current
			toggler.hide();
			displayer.hide();
			editor.show();

			// customForm ONLY this one
			MyFacture.customForm('#'+container.attr('id'));


			var selectMultiple = editor.find('.ms-parent.mutlipleSelect');
			if(editor.find('.ms-parent.mutlipleSelect').length == 0){
                editor.find('.mutlipleSelect').multipleSelect({
                    placeholder: Loc.g("Choisissez des personnes"),
                    width: 450,
                    selectAll: false,
                    filter: false,
                    countSelected : false,
                    selectAllText: Loc.g('Tout Sélectionner'),
                    allSelected: Loc.g('Tous sélectionnés'),
                });
            }



			container.find('input[type="text"].EIP_editorValue').unbind('keydown').keydown(function(event){
				if ( event.which == 13 ) {
					container.find('.save').trigger('click');
				}
			});
			
			container.find('.save, .cancel').unbind('click').click(function(){
				
				displayer.show();
				toggler.show();
				editor.hide();
				if ($(this).hasClass('save')){
					var newValue = container.find('.EIP_editorValue').val();
					var newValueForSave = newValue;
					
					if (container.find('.EIP_editorValue').attr('name') == 'eip_entry_label'){
						var color = container.find('.EIP_editorValue').find('option[value="'+newValue+'"]').attr('color');
						displayer.attr('style', 'background-color:#'+color);
						newValueForSave = newValue;
						newValue = container.find('.EIP_editorValue').find('option[value="'+newValue+'"]').html();
						
					} else if (container.find('.EIP_editorValue').attr('name') == 'eip_entry_linkeduser'){
						var selected = editor.find('select').multipleSelect('getSelects');
						var newUsersLinkedsHtml = '<ul class="entry-linked-users list-inline">';
						$.each(editor.find('select').find('option:selected'),function(i,v){
							
							var peopleName	= $(v).attr('peoplename');
							var peoplepic	= $(v).attr('pics');
							var linkinfo	= $(v).attr('linkinfo');
							var avatartype	= $(v).attr('avatartype');
							var avatarvalue = $(v).attr('avatarvalue');
							var avatarclass = $(v).attr('avatarclass');
							
							if (avatartype == "initials"){
								newUsersLinkedsHtml += '<li linkinfo="'+linkinfo+'"><span class="avatar avatar-small">'+avatarvalue+'</span></li>';
							} else {
								newUsersLinkedsHtml += '<li linkinfo="'+linkinfo+'" tips="'+peopleName+'"><span class="avatar avatar-small avatar-picture"><img src="'+peoplepic+'"/></span></li>';
							}
							
						});
						newUsersLinkedsHtml += "</ul>";
						
						newValue = newUsersLinkedsHtml;
						newValueForSave = selected;
					}

					if (newValue != "" || field == "eip_entry_description" || field == "eip_entry_dueDate"){
						
						displayer.html(newValue);
						var datas = {action:"saveEntryEIP", pid:pid, lid:lid, eid:eid, edit:field, newvalue:newValueForSave};
						MyFacture.post("project_ajax", datas, function(data){
							data.toggleNotification !== undefined && project.toggleNotificationOnOverview(data.toggleNotification == 'Y');
						}, "json");
						
					}
					
					Qtip.init();
					
				}
				
			});
			
			
		});
		
	},
	
	unLinkToEntry : function(pid,lid,eid,linkid){
		
		var options = {
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Délier"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"unLinkElementToEntry", pid:pid, lid:lid, eid:eid, linkid:linkid};
						MyFacture.post("project_ajax", datas, function(data){
							$('.projectOneEntryLink[linkid='+linkid+']').remove();
							if ($('#projectEntryOverview #content_linked .projectOneEntryLink').length == 0){
								$('#projectEntryOverview #content_linked .noLinkedContent').show();
							}
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Délier de l'entrée ?"), options);
		
	},
	
	initEntryOverviewLinker: function(){
		
		var overview = $('#projectEntryOverview');
		
		overview.find('.linkedChooseType').change(function(){
			project.initEntryOverviewLinker();
		});
		
		var pid = overview.attr('pid');
		var lid = overview.attr('lid');
		var eid = overview.attr('eid');
		var linkedType = overview.find('.linkedChooseType').val();
		overview.find('.token-input-list').remove();
		
		switch(linkedType){
			case "purchase":
				TokenInput.autoPurchasesListing("#linkerAutocompleteType", "purOrder|purInvoice|purDelivery", 1, true, 'withdeposit',
					function(item){
						var itemId = item.id.split('_');
						project.entryOverviewLinkElement(itemId[1], 'purchase');
					}
				);
				break;
			case "document":
                var availableDoctypes = $("#availableDoctypes").val();
				TokenInput.autoDocumentListing("#linkerAutocompleteType", availableDoctypes, 1, true, 'withdeposit', 
					function(item){
						var itemId = item.id.split('_');
						project.entryOverviewLinkElement(itemId[1], 'document');
					}
				);
				break;
			case "opportunity":
				TokenInput.autoOpportunity("#linkerAutocompleteType", function(item){
					var itemId = item.id.split('_');
					project.entryOverviewLinkElement(itemId[1], 'opportunity');
				}); 
				break;
			case "support":
				TokenInput.autoSupport('#linkerAutocompleteType', function(item){
					var itemId = item.id.split('_');
					project.entryOverviewLinkElement(itemId[1], 'ticket');
				}); 
				break;
		}
		
		
	},
	
	entryOverviewLinkElement: function(linkedid, linkedtype){
		
		var overview = $('#projectEntryOverview');
		overview.find('#linkerAutocompleteType').tokenInput('clear');
		var pid = overview.attr('pid');
		var lid = overview.attr('lid');
		var eid = overview.attr('eid');
		
		var datas = {action:"linkElementToEntry", pid:pid, lid:lid, eid:eid, linkedid:linkedid, linkedtype:linkedtype};
		MyFacture.post("project_ajax", datas, function(data){
			
			$('#projectEntryOverview #content_linked .noLinkedContent').hide();
			$('#projectEntryOverview #content_linked .linkerContent ul').append(data.projectOneEntryLink);
			$('#projectEntryOverview #content_linked .linkerContent ul').animate({ scrollTop: $('#projectEntryOverview #content_linked .linkerContent ul')[0].scrollHeight}, 500);
			
		}, "json");
	},
	
	saveEntryPreviewTab: function(pid,lid,eid,tab){
		
		if (tab === 'calendarview'){
			setTimeout(function(){
				Agenda.initCalendar($('#calendar').attr('startTime'), $('#calendar').attr('endTime'), $('#calendar').attr('days'));
			}, 1000);
		}
		
		if (tab === "tasks"){
			Agenda.loadTasksTab("projectentry", eid);
		}
		
		var datas = {action:"saveEntryPreviewTab", pid:pid, lid:lid, eid:eid, tab:tab};
		MyFacture.post("project_ajax", datas, function(data){
		}, "json");
		
	},

	reloadEntry: function(pid, lid, eid, asNew){
		
		var asNew = asNew !== undefined;
		
		var datas = {action:"reloadEntryInList", pid:pid, lid:lid, eid:eid};
		MyFacture.post("project_ajax", datas, function(data){
			var entry = data.projectEntry;
			
			if (asNew){
				var entry = data.projectEntry;
				$('.projectOneListCard[eid='+entry.id+']').remove();
				
				if(entry.archived == "Y"){
					$('.projectOneList[lid='+entry.lid+'] .back').find('.emptyList').hide();
					$('.projectOneList[lid='+entry.lid+'] .back').find('.projectOneListCards').append(data.projectEntryHtml);
				} else {
					var cards = $('.projectOneList[lid='+entry.lid+'] .front').find('.projectOneListCard');
					
					if (cards[entry.rank] != undefined){
						$(cards[entry.rank]).before(data.projectEntryHtml);
					} else {
						$('.projectOneList[lid='+entry.lid+'] .front').find('.emptyList').hide();
						$('.projectOneList[lid='+entry.lid+'] .front').find('.projectOneListCards').append(data.projectEntryHtml);
					}
					
					if ($('.projectOneList[lid='+entry.lid+'] .back').find('.projectOneListCard').length === 0 ){
						$('.projectOneList[lid='+entry.lid+'] .back').find('.emptyList').show();
					}
					
				}
				
			} else {
				if(entry.archived == "Y"){
					$('.back .projectOneListCard[eid='+entry.id+']').replaceWith(data.projectEntryHtml);
				} else {
					$('.front .projectOneListCard[eid='+entry.id+']').replaceWith(data.projectEntryHtml);
				}
			}
			
			project.updateNbentries(entry.lid);
			project.refreshCalendar();
			Qtip.init();
			project.initProgressBar();
			project.initLinkedUserDom();
			
		}, "json");
		
	},
	
	entryUserSubscribe : function(pid, lid, eid, subscribe){
		
		var datas = {action:"entryUserSubscribe", pid:pid, lid:lid, eid:eid, subscribe:subscribe};
		MyFacture.post("project_ajax", datas, function(data){

			project.toggleNotificationOnOverview(subscribe == 'Y');

		});
		
	},

	toggleNotificationOnOverview : function(toActivate){
		$('#projectEntryOverview  .projectEntrySubscribe').toggleClass('alreadySubscribed', toActivate);
		$('#projectEntryOverview  .projectEntrySubscribe span').html(toActivate ? Loc.g("Notifications activées") : Loc.g("Notifications désactivées"))
	},

	timetrackingAddCallBack : function(data){
		var html = "";
		html += "<li class='ttentry_"+data.tteid+"'>";
		html += "<div style='position: absolute;left: 16px;top: 8px;'>";
		if (data.avatar === 'initials') {
			html += "<span class='avatar'>";
			html +=     data.avatar.value;
			html += "</div>";
		} else {
			html += "<span class='avatar avatar-picture'>";
			html +=     "<img src='"+data.avatar.value+"' />";
			html += "</div>";
		}
		html += "</div>";
		html += "<div class='ttDescription'>";
		html +=     "<div class='ttDescHeader'>";
		html +=         "<span class='peopleName'>" + data.peopleName + "</span>, ";
		html +=         window.i18n.__('le %(date)s', {'date' : " <b> " + data.date + "</b>"});
		html +=     "</div>";
		html +=     "<div class='ttDescContent'>";;
		html +=         window.i18n.__('A déclaré %(time)s sur le service %(serviceName)s',
			                       {
		                                 'time' : "<b>" + data.time + "</b>",
		                                 'serviceName' : "<a href='" + data.serviceLink + "' target='_blank'>" + data.service + "</a> "
			                       }
				);
		if (data.thirdId !== 0) {
			html += window.i18n.__("pour le client %(clientName)s",	{'clientName' : "<a href='" + data.thirdLink + "' target='_blank'>" + data.third + "</a>"});
		}
		
		html += "</div>";

		if($('#staffCanDeleteEntries').val() == 'Y'){
			html +=			"<div class='ttDescLink'>";
			html +=				"<a href='javascript:;' onClick='TimetrackingEntry.doDelete("+data.tteid+", \"project.timetrackingDeleteCallBack\")'><i class='fa icon-trash'></i></a>";
			html +=			"</div>";
		}

		html +=		"</div>";
		html += "</li>";
		
		$('#content_timetracking .timetrackingList ul').append(html);
		$('#content_timetracking .timetrackingList ul').animate({ scrollTop: $('#content_timetracking .timetrackingList ul')[0].scrollHeight}, 500);
		
		$('#content_timetracking .timetrackingList').find('.noTtEntries').hide();
		
	},
	
	timetrackingDeleteCallBack: function (data){
		
		$('#content_timetracking .timetrackingList ul').find('.ttentry_'+data.timeid).remove();
		
		if ($('#content_timetracking .timetrackingList ul li').length === 0){
			$('#content_timetracking .timetrackingList').find('.noTtEntries').show();
		}
		
	},
	
	deleteCoverImage : function(pid, lid, eid){
		var datas = {action:"deleteCoverImage", pid:pid, lid:lid, eid:eid};
		MyFacture.post("project_ajax", datas, function(data){
			$('#projectEntryOverview .projectEntryCoverImg img').hide();
			$('#projectEntryOverview .projectEntryCoverImg .placeholderImg').show();
			$('#projectEntryOverview .projectEntryCoverImg .deleteCoverImageContainer').hide();
		});
	},
	
	updateEntryCover: function(data){
		
		$('#projectEntryOverview .placeholderImg').hide();		
		$('#projectEntryOverview .projectEntryCoverImg .deleteCoverImageContainer').show();
		$('#projectEntryOverview .projectEntryCoverImg img').attr('src', data.public_path).show();
	}
	
};
